// initial state
const getInitialState = () => ({
  caseLoadId: undefined,
  caseSelectId: undefined,
});
const state = getInitialState();

// getters
const getters = {

  caseLoadId(state) {
    return state.caseLoadId;
  },
  caseSelectId(state) {
    return state.caseSelectId;
  },

};

// mutations
const mutations = {

  caseLoadId(state, value) {
    state.caseLoadId = value;
  },
  caseSelectId(state, value) {
    state.caseSelectId = value;
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
